// extracted by mini-css-extract-plugin
module.exports = {"classic-switch":"header_classic-switch__RhuNc"};